import { createSelector } from '@reduxjs/toolkit';
import { getKitsState } from './kits';

export type PartnerNotesData = Record<
  string,
  {
    partner: {
      id: string;
      name?: string;
    };
    partnerNote: {
      content?: string | null;
    };
    kit: {
      sample_date?: string;
    };
  }
>;

export const getPartnerNotesData = () =>
  createSelector(getKitsState, state => {
    const partnerNotesData: PartnerNotesData = {};

    for (const kit of state.kits ?? []) {
      if (!kit.partner_id || partnerNotesData[kit.partner_id]) continue;
      if (!kit.partner?.partner_notes?.content) continue;

      partnerNotesData[kit.partner_id] = {
        partner: {
          id: kit.partner_id,
          name: kit.partner?.name,
        },
        partnerNote: {
          content: kit.partner.partner_notes.content,
        },
        kit: {
          sample_date: kit.sample_date,
        },
      };
    }

    return partnerNotesData;
  });
